module.exports = __webpack_public_path__ + "img/home_bg_tc.1a74ddc2.png";